/**
 * Professional Noise Paint Worklet
 * 
 * Generates procedural grain/noise textures for realistic material rendering.
 * Excellent for creating "frosted glass", analog paper, or brushed metal effects.
 */

class Noise {
  static get inputProperties() {
    return [
      '--fluent-noise-opacity',
      '--fluent-noise-density',
      '--fluent-noise-size',
      '--fluent-noise-color'
    ];
  }

  paint(ctx: CanvasRenderingContext2D, size: { width: number; height: number }, props: any) {
    const opacity = parseFloat(props.get('--fluent-noise-opacity')) || 0.1;
    const density = parseFloat(props.get('--fluent-noise-density')) || 0.5;
    const dotSize = parseFloat(props.get('--fluent-noise-size')) || 1;
    const color = props.get('--fluent-noise-color').toString() || 'black';

    ctx.save();
    ctx.fillStyle = color;
    ctx.globalAlpha = opacity;

    // We use a deterministic pseudo-random approach for consistency
    // However, in a worklet, we usually just loop or use a pre-calculated pattern
    for (let x = 0; x < size.width; x += dotSize * 2) {
      for (let y = 0; y < size.height; y += dotSize * 2) {
        if (Math.random() < density) {
          ctx.fillRect(x, y, dotSize, dotSize);
        }
      }
    }

    ctx.restore();
  }
}

registerPaint('fluent-noise', Noise);
